<template>
    <div class="icon-check">
        <svg width="40"
             height="40">
            <circle 
                class="icon-check-bg" 
                cx="20" 
                cy="20" 
                r="16"  
            />
            <circle 
                class="icon-check-front" 
                cx="20" 
                cy="20" 
                r="16" 
            />
        </svg>
        <i class="icon-noun_check" />
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.icon-check {
    @include size(40px);
    @include transition(transform .100s ease-in-out 0s);
    position: relative;
    display: inline-block;

    > [class^="icon-noun_"] {
        @include transform(scale(.382));
        @include transition(.150s);
        color: $color-success;
        position: absolute;
        top: 4px;
        left: 5px;
        font-size: 39px;
        opacity: 0;
    }

    > svg {
        @include transform(rotate(-90deg));
        
        > circle {
            fill: transparent;
            opacity: 1;
            stroke-dasharray: 100;
            stroke-width: 4px;

            &.icon-check-bg {
                stroke: $color-border-light;
            }

            &.icon-check-front {
                stroke: rgba($color-primary, .2);
                stroke-dashoffset: -100px;
                opacity: 0;
            }
        }
    }

    // &:before {
    //     content: '';
    //     @include position-cover();
    //     @include border-circle();
    //     border: 4px solid #dedede;
    // }
}
</style>
